import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import { MenuItem, TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { useEffect, useState } from 'react';
import '../ticketKnowledge/DrilldownAndDetailSearch.css';
import { createFilterOptions } from '@material-ui/lab/Autocomplete';
import { I18n } from 'aws-amplify';
import './ShareFormField.css';
import { useRecoilValue } from 'recoil';
import { corporationAtom } from '@/state/atom/corporationAtom';

export default function ShareField(props) {
    const corporationDetail = useRecoilValue(corporationAtom);
    const indexAddField = Utils.findIndexInArrayById(props.currentAddField.id, props.fieldAddList);

    const getDetailFieldValue = () => {
        const fieldAddValue = Utils.findObjectById(props.currentAddField.id, props.fieldAddList);
        let detailFieldValue = {};
        detailFieldValue = { ...fieldAddValue };
        if(detailFieldValue.newShareOption){
            detailFieldValue.shareOption = detailFieldValue.newShareOption;
        }

        if(detailFieldValue.newShareRange){
            detailFieldValue.shareRange = detailFieldValue.newShareRange;
        }

        return detailFieldValue;
    };
   
    const detailField = getDetailFieldValue();
    const corporationNotShareDestination = detailField?.affiliationOrganization || corporationDetail?.id;
    
    const [shareOption, setShareOption] = useState();
    const [isShareDestination, setIsShareDestination] = useState(false);

    const [listOrg, setListOrg] = useState([]);
    const [selectedOrgs, setSelectedOrgs] = useState([]);
    const [isOrgsSelected, setIsOrgsSelected] = useState(false);

    const onChangeSelectedOrgs = (_, value) => {
        setSelectedOrgs(value);
        let listOrgId = [];
        value?.forEach(option => {
            listOrgId.push(option.id);
        });
        setNewShareRangeToFieldAddList([...listOrgId]);
        setIsOrgsSelected(true);
        if (value.length > 0) {
            props.setIsChangeData(true);
        } else {
            props.setIsChangeData(false);
        }
    };

    const onChangeShareOption = event => {
        let cloneFieldAddList = [...props.fieldAddList];
        let shareOptionValue = event.target.value;
        setShareOption(shareOptionValue);
        cloneFieldAddList[indexAddField].newShareOption = shareOptionValue;
        props.setFieldAddList(cloneFieldAddList);
        setIsOrgsSelected(false);
        setNewShareRangeToFieldAddList([]);
        if (
            [
                Constant.SHARE_OPTION.SPECIFIC_ORG,
                Constant.SHARE_OPTION.B2B_CUSTOMER_ORG,
                Constant.SHARE_OPTION.B2B_HELPDESK_ORG
            ].includes(shareOptionValue)
        ) {
            props.setIsChangeData(false);
        } else {
            props.setIsChangeData(true);
        }
    };

    const filterSugguestionOption = createFilterOptions({
        ignoreCase: false,
        stringify: option => `${option.title} ${option.subDomain}`
    });

    const setNewShareRangeToFieldAddList = value => {
        let cloneFieldAddList = [...props.fieldAddList];
        cloneFieldAddList[indexAddField].newShareRange = value;
        cloneFieldAddList[indexAddField].newShareOption = shareOption
        props.setFieldAddList(cloneFieldAddList);
    };

    useEffect(() => {
        if (detailField?.shareOption) {
            setShareOption(detailField.shareOption);
        }
    }, []);

    useEffect(() => {
        let listOptions = [];
        let currentShareRange = Utils.isEmptyArray(detailField?.shareRange)
            ? []
            : detailField?.shareRange;
        switch (shareOption) {
            case Constant.SHARE_OPTION.SPECIFIC_ORG:
                listOptions = props?.allListCorp;
                if (corporationNotShareDestination) {
                    listOptions = listOptions.filter(corp => corp?.id !== corporationNotShareDestination);
                }
                setListOrg([...listOptions]);
                setIsShareDestination(true);
                break;
            case Constant.SHARE_OPTION.B2B_CUSTOMER_ORG:
                listOptions = props.b2bCustomerList;
                setListOrg(props.b2bCustomerList);
                setIsShareDestination(true);
                break;
            case Constant.SHARE_OPTION.B2B_HELPDESK_ORG:
                listOptions = props.b2bHelpDeskList;
                setListOrg(props.b2bHelpDeskList);
                setIsShareDestination(true);
                break;
            default:
                setIsShareDestination(false);
                break;
        }
        // default value of share range
        if (detailField?.shareOption && detailField?.shareOption === shareOption) {
            let selectOption = listOptions?.filter(option => {
                return (
                    currentShareRange.includes(option.id) &&
                    option.active !== Constant.CORPORATION_ACTIVE.DELETED
                );
            });
            setNewShareRangeToFieldAddList(currentShareRange);
            setSelectedOrgs([...selectOption]);
        } else {
            if (shareOption) {
                setNewShareRangeToFieldAddList([]);
            }
            setSelectedOrgs([]);
        }
    }, [shareOption]);

    const filterBlockAndDeleteOrg = orgList => {
        if (corporationNotShareDestination) {
            orgList = orgList?.filter(org => org.id !== corporationNotShareDestination);
        }

        return orgList?.filter(
            org =>
                org.active !== Constant.CORPORATION_ACTIVE.BLOCK &&
                org.active !== Constant.CORPORATION_ACTIVE.DELETED
        );
    };

    return (
        <>
            <div className="lstCreateForm">
                <p className="share-option-text">共有範囲</p>
                <div className="share-option-control">
                    <TextField
                        className="form-control--wrap form-control--hg32"
                        select
                        variant="outlined"
                        SelectProps={{
                            MenuProps: {
                                anchorOrigin: {
                                    vertical: 'bottom',
                                    horizontal: 'left'
                                },
                                getContentAnchorEl: null,
                                className: 'selectDrop'
                            }
                        }}
                        defaultValue={
                            detailField?.shareOption
                                ? detailField?.shareOption
                                : Constant.SHARE_OPTION.INTERNAL_ORG
                        }
                        value={shareOption}
                        onChange={onChangeShareOption}
                    >
                        <MenuItem value={Constant.SHARE_OPTION.INTERNAL_ORG}>組織内</MenuItem>
                        <MenuItem value={Constant.SHARE_OPTION.SPECIFIC_ORG}>特定の他組織</MenuItem>
                        {/* {!Utils.isEmptyArray(props.b2bCustomerList) && ( */}
                            <MenuItem value={Constant.SHARE_OPTION.B2B_CUSTOMER_ORG}>
                                B2Bカスタマー組織
                            </MenuItem>
                        {/* )} */}
                        {/* {!Utils.isEmptyArray(props.b2bHelpDeskList) && ( */}
                            <MenuItem value={Constant.SHARE_OPTION.B2B_HELPDESK_ORG}>
                                B2Bサポート組織
                            </MenuItem>
                        {/* )} */}
                        <MenuItem value={Constant.SHARE_OPTION.ALL_ORG}>全組織</MenuItem>
                    </TextField>
                </div>
            </div>
            {isShareDestination && (
                <div className="lstCreateForm">
                    <label className="share-option-text">共有先</label>
                    <div className="share-option-control">
                        <Autocomplete
                            className="search-option-tag-content"
                            multiple
                            filterSelectedOptions
                            filterOptions={filterSugguestionOption}
                            getOptionLabel={option => {
                                let label =
                                    option.active === Constant.CORPORATION_ACTIVE.BLOCK
                                        ? `${option?.title} ${option?.subDomain} (停止中)`
                                        : `${option?.title} ${option?.subDomain}`;
                                return label;
                            }}
                            options={filterBlockAndDeleteOrg(listOrg)}
                            value={selectedOrgs}
                            openOnFocus={true}
                            onChange={onChangeSelectedOrgs}
                            renderInput={params => (
                                <TextField
                                    {...params}
                                    variant="outlined"
                                    className="form-control form-control-wrapTextarea"
                                    placeholder={I18n.get('USER04P009')}
                                    error={isOrgsSelected && selectedOrgs.length === 0}
                                    helperText={
                                        isOrgsSelected && selectedOrgs.length === 0
                                            ? I18n.get('COMMSG014')
                                            : ''
                                    }
                                />
                            )}
                            ListboxProps={{
                                style: { maxHeight: 376, overflow: 'auto', overflowX: 'hidden' }
                            }}
                            noOptionsText={I18n.get('COMMSG001')}
                        ></Autocomplete>
                    </div>
                </div>
            )}
        </>
    );
}
